const config = {
  //server_ip: "http://localhost:4000",
  server_ip: "https://server2.encontrorenal.com",
};

export default config;
